import { render, staticRenderFns } from "./DialogInputOffingWavePoint.vue?vue&type=template&id=745e005d&"
import script from "./DialogInputOffingWavePoint.vue?vue&type=script&lang=js&"
export * from "./DialogInputOffingWavePoint.vue?vue&type=script&lang=js&"
import style0 from "./DialogInputOffingWavePoint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports